export const ipAddressPattern = `^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$`;
export const ipAddressRegExp = new RegExp(ipAddressPattern);

export default { ipAddressPattern, ipAddressRegExp };
